import crud from '@/crud/index/index'
import resources from '../../resources'

export default {

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/documents/index/resources/index.js